"use strict";

var React = require('react');

var _require = require('../contexts/translate-context'),
    useTranslateContext = _require.useTranslateContext;

var useTranslations = function useTranslations() {
  var _useTranslateContext = useTranslateContext(),
      staticTranslations = _useTranslateContext.staticTranslations;

  var t = function t(strings) {
    var index = strings.raw[0];
    var translation = staticTranslations && staticTranslations.hasOwnProperty(index) ? staticTranslations[index] : index;
    return translation;
  };

  return t;
};

module.exports = useTranslations;